import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPrintFileJobs as getPrintFileJobsApi, IPrintFileJobsQueryParams } from '../../api/printFileJobs';
import store from '../../store';
import { setNotifications } from '../slices/notifications';

export const getPrintFileJobs = createAsyncThunk(
    'printFileJobs/getPrintFileJobs',
    async (queryParams: IPrintFileJobsQueryParams, { rejectWithValue }) => {
        try {
            return await getPrintFileJobsApi(queryParams);
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message, type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);
